if (!customElements.get('rm-package-components')) {
  customElements.define('rm-package-components', class extends HTMLElement {
    constructor() {
      super();
      this.expanded = false;
      this.onToggle = () => {
        this.expanded = !this.expanded;
        this.update();
      };
      this.onResize = () => this.update();
    }

    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.rm-package-components__item'));
      this.button = this.querySelector('.rm-package-components__toggle');
      this.media = window.matchMedia('(max-width: 749px)');
      this.button.addEventListener('click', this.onToggle);
      this.media.addEventListener('change', this.onResize);
      this.update();
    }

    disconnectedCallback() {
      this.button.removeEventListener('click', this.onToggle);
      this.media.removeEventListener('change', this.onResize);
    }

    update() {
      const firstRow = this.media.matches ? 1 : 2;
      this.items.forEach((item, index) => {
        item.hidden = !this.expanded && index >= firstRow;
      });
      this.button.hidden = this.items.length <= firstRow;
      this.button.setAttribute('aria-expanded', String(this.expanded));
      this.button.querySelector('span').textContent = this.expanded
        ? 'Show fewer'
        : 'View all ' + this.items.length + ' types';
      this.button.querySelector('path').setAttribute('d', this.expanded
        ? 'm2 8 4-4 4 4'
        : 'm2 4 4 4 4-4');
    }
  });
}
